
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTransformMove as ObiTransformMoveElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-transform-move.js';
 
 
 

 
 export const ObiTransformMove = createComponent({
   react: React,
   tagName: 'obi-transform-move',
   elementClass: ObiTransformMoveElement,
   events: {
     
   }
  });
 
 